import React, { useCallback, useEffect }  from "react"
import useHistoryState from "../useHistoryState"
import { useSelector } from "react-redux"
import {  RootReducer } from "../app/reducer"

    type Props = {
        id? : string,
        name: string,
        nameTo?:string,
        label?: string        
        interval?:"before" | "from" | "fromTo" 
        reset?:number
    }
//When the name property is not set then the item is not taken into data (see security-criteria.tsx - onSubmitHandle)
export const InputDateCl : React.FC<Props> = props  => {    
    
    const windowHistoryState : any = useSelector((state:RootReducer) =>  state.securityResultReducer.secWindowHistoryState );
    const months = [{id:"01", description: "January"}, {id:"02", description: "February"}, {id:"03", description: "March"},{id:"04", description: "April"},
                    {id:"05", description: "May"}, {id:"06", description: "June"}, {id:"07", description: "July"}, {id:"08", description: "August"},
                    {id:"09", description: "September"}, {id:"10", description: "October"}, {id:"11", description: "November"}, {id:"12", description: "December"}
                   ];
    const currentDate = new Date();
    const selectMonth  = String((currentDate.getMonth() + 1) < 10 ? "0" + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1 );        
    //Set Initial states of the component
    const setInitialElmState = {checked:false, disabled: true};    
    const setInitialValueState = {Day: String(currentDate.getDate()),
                                  Month: selectMonth,
                                  Year: String (currentDate.getFullYear()),
                                  ToDay: String(currentDate.getDate()),
                                  ToMonth: selectMonth,
                                  ToYear: String (currentDate.getFullYear()),
                                 };

    const [elmState, setCheckBox] = useHistoryState("setCheckBox" + props.name, setInitialElmState);                  
    const [valueState, setState] = useHistoryState("setState" + props.name, setInitialValueState);
   
    useEffect(() => {               
        if (props.reset !== 0) {
            setCheckBox(setInitialElmState);
            setState(setInitialValueState);
        }
       // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [props.reset])
    
    //The below useEffect is used to maintain history when moving between pages
    useEffect(() => {                               
        if( windowHistoryState && windowHistoryState["setCheckBox" + props.name] ) {        
             setCheckBox(windowHistoryState["setCheckBox" + props.name]);          
        }
        if (windowHistoryState && windowHistoryState["setState" + props.name]) {
            setState(windowHistoryState["setState" + props.name]);
        }
       // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [windowHistoryState])    

    const handleClick = useCallback( () => {
        setCheckBox( {checked: ! elmState.checked, disabled: ! elmState.disabled} )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [elmState]);
    
    const handleChange = useCallback( (evt : any) => {
        const value = evt.target.value;
        setState({
            ...valueState,
            [evt.target.id]: value                
            });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valueState])
    
    return(
        <>        
        <div className="search-table-row">
            <span className="search-table-col-left">{props.label}</span>
            <span className="search-table-col-right-grid">
                <span className=".search-table-col-right-grid-item1"> 
                    <input id="switch" type="checkbox" onClick={handleClick} checked={elmState.checked} />   
                </span>            
                <span className="search-table-col-right-grid-item2"> 
                    {props.interval?.indexOf("from") === 0 ? "from : " : "" }    
                    {props.interval === "before" ? "before : " : "" }                  
                </span>            
                <span className="search-table-col-right-grid-item3"> 
                    <input id="Day" type="text" value={valueState.Day} onChange={handleChange} disabled = {elmState.disabled} maxLength={2} size={3}/> 
                </span>
                <span className="search-table-col-right-grid-item4"> 
                    <select  id="Month" disabled = {elmState.disabled} value={valueState.Month} onChange={handleChange} size={1} >                    
                        {months.map( month => <option key={month.id+month.description} value={month.id} >{month.description}  </option>)}
                    </select> 
                </span>
                <span className="search-table-col-right-grid-item5"> 
                    <input id="Year" type="text" value={valueState.Year} onChange={handleChange} disabled = {elmState.disabled} maxLength={4} size={3}/>     
                    <input id="firstDate" name={props.name} type="hidden" disabled = {elmState.disabled}
                       value={Number(valueState.Day) < 10 ? '0' + Number(valueState.Day)  + valueState.Month + valueState.Year 
                                                          : valueState.Day   + valueState.Month + valueState.Year} /> 
                </span>
                
                {props.interval === "fromTo"  && 
                    <>
                        <span className="search-table-col-right-grid-item6"> 
                            To :     
                        </span>
                        <span className="search-table-col-right-grid-item7"> 
                            <input id="ToDay" type="text" value={valueState.ToDay} onChange={handleChange} disabled = {elmState.disabled} maxLength={2} size={3}/> 
                        </span>
                        <span className="search-table-col-right-grid-item8"> 
                            <select  id="ToMonth" disabled = {elmState.disabled} value={valueState.ToMonth} onChange={handleChange} >                    
                                {months.map( month => <option key={month.id+month.description} value={month.id} >  {month.description} </option>)}
                            </select> 
                        </span>
                        <span className="search-table-col-right-grid-item9"> 
                            <input id="ToYear" type="text" value={valueState.ToYear} onChange={handleChange} disabled = {elmState.disabled} maxLength={4} size={3} />
                            <input id="ToDate" name={props.nameTo} type="hidden" disabled = {elmState.disabled}
                                value={Number(valueState.ToDay) < 10 ? '0' + Number(valueState.ToDay)  + valueState.ToMonth + valueState.ToYear 
                                                                     : valueState.ToDay  + valueState.ToMonth + valueState.ToYear} /> 
                        </span>            
                    </>
                }
            </span> 
        </div>                                                         
        </>
    )
}
